const galleryContainerElement = document.querySelectorAll(".gallery-container")
const licenseKey = "C789E420-34844F09-94EB07AB-DE2E7417"

function initialiseLightGallery(container) {
  const setLightGallery = (galleryElement) => {
    return lightGallery(galleryElement, {
      plugins: [],
      speed: 500,
      licenseKey: licenseKey,
      zoomFromOrigin: true,
      selector: ".showing",
    })
  }

  const setActiveButton = (button, filterButtons) => {
    filterButtons.forEach((button) => {
      button.classList.remove("active")
    })
    button.classList.add("active")
  }

  const setActiveOption = (option, options) => {
    options.forEach((option) => {
      option.removeAttribute("selected")
    })
    option.setAttribute("selected", "")
  }

    const galleryElement = container.querySelector(".gallery-images-js")

    if (!galleryElement) {
      return
    }

    let lightGalleryPlugin = setLightGallery(galleryElement)

    const filterButtons = container.querySelectorAll(".filter-buttons > button")
    const select = container.querySelector(".filter-select")
    let options = []
    if (select) {
      options = select.querySelectorAll("option")
    }

    const filterButtonPressed = (button) => {
      filterImages(container, button)
      setActiveButton(button, filterButtons)
      lightGalleryPlugin.destroy()
      lightGalleryPlugin = setLightGallery(galleryElement)
    }

    const selectOptionChanged = (option) => {
      filterImages(container, option)
      setActiveOption(option, options)
      lightGalleryPlugin.destroy()
      lightGalleryPlugin = setLightGallery(galleryElement)
    }

    if (filterButtons) {
      filterButtons.forEach((button, index) => {
        if (button.dataset.filter_no == "0") {
          filterButtonPressed(button)
        }
        button.addEventListener("click", function (e) {
          filterButtonPressed(button)
        })
      })
    }

    if (select) {
      select.addEventListener("change", (e) => {
        selectOptionChanged(select.options[select.selectedIndex])
      })

      options.forEach((option, index) => {
        if (option.dataset.filter_no == "0") {
          selectOptionChanged(option)
        }
      })
    }

    if (!select && filterButtons.length == 0) {
      showAllImages(container)
      lightGalleryPlugin.destroy()
      lightGalleryPlugin = setLightGallery(galleryElement)
    }
}

function initialiseDynamicLightGallery() {
  document.querySelectorAll(".thumbnail-gallery").forEach(function (card) {
    const galleryButton = card.querySelector(".gallery-cta")
    const dynamicElements = []

    if (galleryButton) {
      card.querySelectorAll(".card-image").forEach(function (image) {
        dynamicElements.push({
          src: image.dataset.src,
          thumb: image.dataset.src,
          subHtml: image.dataset.description,
        })
      })

      if (dynamicElements.length > 0) {
        const dynamicGallery = lightGallery(galleryButton, {
          licenseKey: licenseKey,
          plugins: [lgThumbnail],
          dynamic: true,
          dynamicEl: dynamicElements,
          thumbnail: true,
        })

        galleryButton.addEventListener("click", function () {
          dynamicGallery.openGallery()
        })
      }
    }
  })
}

function initialiseMasonry(container) {
  const masonryGrid = container.querySelector(".masonry-grid")
  const filterButtons = container.querySelectorAll(".filter-buttons > button")
  const selects = container.querySelectorAll(".filter-select")

  if (!masonryGrid) {
    return
  }

  const reinitialiseMasonry = (masonryGrid) => {
    return new Masonry(masonryGrid, {
      itemSelector: ".showing",
    })
  }

  const reloadMasonry = (masonry, masonryGrid) => {
    masonry.destroy()
    masonry = reinitialiseMasonry(masonryGrid)
    masonry.reloadItems()
    return masonry
  }

  const watchFilterButtons = (filterButtons, selects) => {
    filterButtons.forEach((filterButton) => {
      filterButton.addEventListener("click", (e) => {
        masonry = reloadMasonry(masonry, masonryGrid)
      })
    })

    selects.forEach((select) => {
      select.addEventListener("change", (e) => {
        masonry = reloadMasonry(masonry, masonryGrid)
      })
    })
  }

  let masonry = reinitialiseMasonry(masonryGrid)
  masonry = reloadMasonry(masonry, masonryGrid)
  watchFilterButtons(filterButtons, selects)
}

function showAllImages(container, button) {
  const showImage = (image) => {
    image.style.display = "block"
    image.classList.add("showing")
  }

  const images = container.querySelectorAll(".gallery-image")
  images.forEach((image) => {
    showImage(image)
  })
}

function filterImages(container, button) {
  const showImage = (image) => {
    image.style.display = "block"
    image.classList.add("showing")
  }

  const hideImage = (image) => {
    image.style.display = "none"
    image.classList.remove("showing")
  }

  const images = container.querySelectorAll(".gallery-image")
  images.forEach((image) => {
    hideImage(image)

    const imageFilters = JSON.parse(image.dataset.filters)
    const selectedFilter = button.dataset.filter

    if (imageFilters.includes(selectedFilter)) {
      showImage(image)
    }
    if (selectedFilter == "none") {
      showImage(image)
    }
  })
}

window.addEventListener("load", (event) => {
  galleryContainerElement.forEach(container => {
    const loadingSpinner = container.querySelector('#loading-spinner')

    imagesLoaded(container, function( instance ) {
      initialiseLightGallery(container)
      initialiseMasonry(container)
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none'
      }
    });
  });

  initialiseDynamicLightGallery()
})

